import { render, staticRenderFns } from "./CourseStoreManagement.vue?vue&type=template&id=3fcb9f95&scoped=true&"
import script from "./coursestoremanagement.js?vue&type=script&lang=js&"
export * from "./coursestoremanagement.js?vue&type=script&lang=js&"
import style0 from "./CourseStoreManagement.vue?vue&type=style&index=0&id=3fcb9f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb9f95",
  null
  
)

export default component.exports